module.exports = __webpack_public_path__ + "04_short_gold.8481c3cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/04_short_gold.png
// module id = NS+q
// module chunks = 0